export { default } from './AxisGQL.vue'
